import { useCallback } from 'react';

import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';

import type { ParentPageData } from '../components/types.ts';

export const useGoToPage = (): ((pageData: ParentPageData | null) => void) => {
	const { push } = useRouteActions();
	return useCallback(
		(pageData: ParentPageData | null) => {
			if (!pageData) {
				return;
			}
			push(`/wiki/spaces/${pageData.space}/pages/${pageData.id}`);
		},
		[push],
	);
};
